import React from 'react';
import { ReactComponent as ModalIcon } from '../../images/Icons/happycoins_more.svg';

export default function ModalsHeaderHappycoinsWonMore() {

  return (
    <div>
      <div className="ModalsHeader blue">
        <div>
          <ModalIcon/>
        </div>
      </div>
      <div className="ModalsHeaderShadow"></div>
    </div>
  );
}
